import React, { useEffect, useState } from "react";
import ErrorMessage from "./ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import {
  makeDashboardError,
  setDashboardError,
} from "@client.pages/Dashboard/reducer";
import { clearChartsError } from "@client.components/Charts/reducer";
import {
  makeReportsError,
  setReportsError,
} from "@client.pages/Reports/reducer";
import {
  makeSettingsError,
  setSettingsError,
} from "@client.pages/Settings/reducer";

const AuthorizedErrorMessage = () => {
  const dashboardError = useSelector(makeDashboardError);
  const reportsError = useSelector(makeReportsError);
  const settingsError = useSelector(makeSettingsError);

  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (dashboardError || reportsError || settingsError) {
      setError(dashboardError || reportsError || settingsError);
    }
  }, [dashboardError, reportsError, settingsError]);

  return (
    <ErrorMessage
      className="error-page-message"
      template="components.generalError"
      onClose={() => {
        if (dashboardError) {
          dispatch(setDashboardError(null));
          dispatch(clearChartsError());
        }

        if (reportsError) {
          dispatch(setReportsError(null));
          dispatch(clearChartsError());
        }

        if (settingsError) {
          dispatch(setSettingsError(null));
        }
        setError(null);
      }}
      message={error}
    />
  );
};

export default AuthorizedErrorMessage;
